import { render, staticRenderFns } from "./JSearchSelectTagOptionIsValueText.vue?vue&type=template&id=1154d366&scoped=true&"
import script from "./JSearchSelectTagOptionIsValueText.vue?vue&type=script&lang=js&"
export * from "./JSearchSelectTagOptionIsValueText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1154d366",
  null
  
)

export default component.exports